var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"---mr-4",class:_vm.classes,attrs:{"to":_vm.path},nativeOn:{"click":function($event){return _vm.click.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.valueFunc ? _vm.valueFunc(_vm.record) : _vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }